export type DeaneryOption = {
  id: number;
  name: string;
};

export type ParishOption = {
  id: number;
  value: string;
};

export const deaneryList: DeaneryOption[] = [
  { id: 1, name: "Kundapur" },
  { id: 2, name: "Udupi" },
  { id: 3, name: "Karkala" },
  { id: 4, name: "Kallianpur" },
  { id: 5, name: "Shirva" },
];

const kundapurParishList: ParishOption[] = [
  { id: 1, value: "Basrur" },
  { id: 2, value: "Belve" },
  { id: 3, value: "Byndoor" },
  { id: 4, value: "Kundapur" },
  { id: 5, value: "Gangolli" },
  { id: 6, value: "Kota" },
  { id: 7, value: "Koteshwar" },
  { id: 8, value: "Padukone" },
  { id: 9, value: "Piusnagar" },
  { id: 10, value: "Tallur" },
  { id: 11, value: "Trasi" },
  { id: 12, value: "Kerekatte" },
  { id: 13, value: "Kandlur" },
];

const karkalaParishList: ParishOption[] = [
  { id: 14, value: "Ajekar" },
  { id: 15, value: "Hirgan" },
  { id: 16, value: "Miyar" },
  { id: 17, value: "Karkal-Attur" },
  { id: 18, value: "Karkal-Town" },
  { id: 19, value: "Parapady" },
  { id: 20, value: "Nakre" },
  { id: 21, value: "Kanajar" },
  { id: 22, value: "Kera" },
];

const shirvaParishList: ParishOption[] = [
  { id: 23, value: "Belman" },
  { id: 24, value: "Kalathur" },
  { id: 25, value: "Kelmbet" },
  { id: 26, value: "Mudarangadi" },
  { id: 27, value: "Mukamar" },
  { id: 28, value: "Palimar" },
  { id: 29, value: "Pamboor" },
  { id: 30, value: "Mundkur" },
  { id: 31, value: "Pernal" },
  { id: 32, value: "Shirva" },
  { id: 33, value: "Pangla" },
  { id: 34, value: "Pilar" },
];

const udupiParishList: ParishOption[] = [
  { id: 35, value: "Moodubelle" },
  { id: 36, value: "Kalmady" },
  { id: 37, value: "Katapady" },
  { id: 38, value: "Kuntalnagar" },
  { id: 39, value: "Manipal" },
  { id: 40, value: "Perampally" },
  { id: 41, value: "Udupi" },
  { id: 42, value: "Udyavar" },
  { id: 43, value: "Yermal" },
];

const kallianpurParishList: ParishOption[] = [
  { id: 44, value: "Barkur" },
  { id: 45, value: "Brahmavar" },
  { id: 46, value: "Kolalgiri" },
  { id: 47, value: "Kallianpur-Milagres" },
  { id: 48, value: "Kallianpur-Mount Rosary" },
  { id: 49, value: "Thottam" },
  { id: 50, value: "Kemman" },
  { id: 51, value: "Pethri" },
  { id: 52, value: "Sastan" },
];

export const parishListMap: Record<string, ParishOption[]> = {
  Kundapur: kundapurParishList,
  Karkala: karkalaParishList,
  Shirva: shirvaParishList,
  Udupi: udupiParishList,
  Kallianpur: kallianpurParishList,
};
